import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            吃瓜热度榜
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">全网最热门的瓜都在这里，实时更新排名</p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200/60 hover:bg-background-100/60 transition-all duration-200 cursor-pointer"
            >
              <div className="flex-shrink-0 w-9 h-9 flex items-center justify-center">
                {item.rank <= 3 ? (
                  <span className={`text-lg font-bold ${item.rank === 1 ? 'text-primary-500' : item.rank === 2 ? 'text-accent-500' : 'text-secondary-500'}`} style={{ fontFamily: 'var(--font-heading)' }}>
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-medium text-foreground-400">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className={`flex-shrink-0 text-[10px] font-bold px-1.5 py-0.5 rounded ${
                    item.tag === '爆' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '热' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>{item.tag}</span>
                  <span className="text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors truncate">{item.title}</span>
                </div>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1 text-xs text-foreground-400">
                {item.trend === 'up' ? (
                  <i className="ri-arrow-up-line text-primary-500 text-sm"></i>
                ) : (
                  <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>
                )}
                <span>{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}